export const SEARCH_PARAMS_TAB_KEY = 'tab'
export const SEARCH_PARAMS_WEEK_START_KEY = 'weekStart'

export const WORK_ORDER_TAB_TODAY = 'today' as const
export const WORK_ORDER_TAB_JOB_BOARD = 'job-board' as const
export const WORK_ORDER_TAB_LIST = 'list' as const

export const WORK_ORDER_TAB_LINKS = [
  { value: WORK_ORDER_TAB_TODAY, label: 'Today' },
  { value: WORK_ORDER_TAB_JOB_BOARD, label: 'Job Board' },
  { value: WORK_ORDER_TAB_LIST, label: 'Work Orders' },
] as const

export type WorkOrderTabValue = (typeof WORK_ORDER_TAB_LINKS)[number]['value']
